import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgNoResults(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M34.161 15.453h44.576c1.193 0 2.253.75 2.695 1.855l2.341 6.141.22 81.685H28.772l.221-81.685 2.518-6.185a2.867 2.867 0 0 1 2.651-1.811Z"
        fill="#80CCB5"
      />
      <path
        d="M31.643 21.281h49.48a2.866 2.866 0 0 1 2.871 2.872v83.938a2.866 2.866 0 0 1-2.871 2.872h-49.48a2.866 2.866 0 0 1-2.872-2.872V24.153a2.866 2.866 0 0 1 2.872-2.872Z"
        fill="#CAE8DF"
      />
      <path
        d="M80.758 68.237a2.067 2.067 0 0 0-2.073-2.07H34.95a2.066 2.066 0 0 0-2.071 2.07v29.159c0 1.148.923 2.07 2.071 2.071h43.736a2.066 2.066 0 0 0 2.073-2.071V68.237Zm1.6 29.159a3.666 3.666 0 0 1-3.673 3.671H34.95a3.666 3.666 0 0 1-3.67-3.671V68.237a3.665 3.665 0 0 1 3.67-3.67h43.736a3.666 3.666 0 0 1 3.672 3.67v29.159Z"
        fill="#0F172A"
      />
      <path
        d="M34.508 30.024h43.736a2.866 2.866 0 0 1 2.871 2.872v29.157a2.866 2.866 0 0 1-2.871 2.872H34.508a2.866 2.866 0 0 1-2.872-2.872V32.896a2.866 2.866 0 0 1 2.872-2.872Z"
        fill="#0F172A"
      />
      <path d="m82.308 37.8-5.522-7.776H35.79l-4.418 7.731 50.937.044Z" fill="#42A486" />
      <path
        d="M33.624 36.65H80.01a2.866 2.866 0 0 1 2.871 2.872V68.68a2.866 2.866 0 0 1-2.871 2.871H33.624a2.866 2.866 0 0 1-2.872-2.871V39.522a2.866 2.866 0 0 1 2.872-2.871Z"
        fill="#599F40"
      />
      <path
        d="M52.348 84.884c-1.213 0-2.205-.843-2.205-1.943h13.6c-.074 1.063-1.03 1.943-2.243 1.943h-9.152Z"
        fill="#42A486"
      />
      <path d="M92.701 109.852a.8.8 0 0 1 0 1.6H21a.8.8 0 1 1 0-1.6h71.701Z" fill="#0F172A" />
      <path d="M32.9 71h47.9v3a2 2 0 0 1-2 2H34.9a2 2 0 0 1-2-2v-3Z" fill="#A6DBCB" />
      <path
        d="M27.972 27.11V25.28a4.8 4.8 0 0 1 4.8-4.8h33.885a.8.8 0 0 1 0 1.6H32.771a3.2 3.2 0 0 0-3.2 3.2v1.828a.8.8 0 1 1-1.6 0Z"
        fill="#0F172A"
      />
      <path
        d="M33.624 36.824H80.01a2.866 2.866 0 0 1 2.871 2.872v29.157a2.866 2.866 0 0 1-2.871 2.872H33.624a2.866 2.866 0 0 1-2.872-2.872V39.696a2.866 2.866 0 0 1 2.872-2.872Z"
        fill="#CAE8DF"
      />
      <path
        d="M29.875 68.68V39.522c0-1.21.583-2.283 1.483-2.951a.8.8 0 0 1 .954 1.285c-.51.377-.837.98-.837 1.666V68.68c0 1.148.923 2.071 2.07 2.072h46.389a2.066 2.066 0 0 0 2.07-2.072V39.522c0-.832-.483-1.545-1.187-1.876a.8.8 0 1 1 .681-1.447 3.665 3.665 0 0 1 2.106 3.323V68.68a3.665 3.665 0 0 1-3.67 3.671H33.546a3.665 3.665 0 0 1-3.671-3.67Z"
        fill="#0F172A"
      />
      <path
        d="M52.348 54.77c-1.213 0-2.205-.843-2.205-1.943h13.6c-.074 1.063-1.03 1.943-2.243 1.943h-9.152Z"
        fill="#42A486"
      />
      <path
        d="M72.457 32.361a.8.8 0 0 1 .983.559c.147.531.309 1.055.482 1.567a.8.8 0 1 1-1.516.51 30.559 30.559 0 0 1-.509-1.652.8.8 0 0 1 .56-.984Zm-.38-6.69a.8.8 0 0 1 .706.883 14.276 14.276 0 0 0 .025 3.185.8.8 0 1 1-1.59.18 15.862 15.862 0 0 1-.026-3.541.8.8 0 0 1 .884-.707Zm1.867-5.836a.801.801 0 0 1 1.235 1.018c-.71.86-1.24 1.754-1.622 2.668a.801.801 0 0 1-1.476-.618 12.23 12.23 0 0 1 1.863-3.068Zm5.567-4.274a.8.8 0 0 1 .725 1.426 18.829 18.829 0 0 0-2.747 1.69.8.8 0 0 1-.959-1.28c.87-.651 1.86-1.265 2.98-1.836Zm6.466-2.395a.8.8 0 0 1 .412 1.547c-1.135.302-2.182.63-3.146.98a.8.8 0 0 1-.547-1.504 38.784 38.784 0 0 1 3.28-1.023Zm5.027-1.07a.8.8 0 1 1 .263 1.579c-.564.094-1.111.193-1.643.297a.8.8 0 1 1-.307-1.57 61.615 61.615 0 0 1 1.687-.305Z"
        fill="#0F172A"
      />
      <path
        d="M99.76 11.23s-4.817-3.181-5.7-1.944c-.884 1.237.883 2.783 1.679 2.783.706-.044 4.02-.84 4.02-.84Z"
        fill="#A6DBCB"
      />
      <path
        d="M99.759 11.362s-3.181 4.816-4.507 4.02c-1.325-.75-.265-2.915.442-3.18.751-.31 4.065-.84 4.065-.84Z"
        fill="#A6DBCB"
      />
      <path
        d="M97.222 12.838c1.625-.334 2.851-1.05 2.738-1.6-.113-.55-1.522-.725-3.148-.39-1.625.334-2.85 1.05-2.738 1.6.114.55 1.523.725 3.148.39Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgNoResults)
